// extracted by mini-css-extract-plugin
export default {"currency":"Currency--currency--a14e8b"};